import React from "react";

interface DashboardCardProps {
  title: string;
  count: number | string;
  icon: React.ReactNode;
}

export function DashboardCard({ title, count, icon }: DashboardCardProps) {
  return (
    <div className="bg-white rounded-lg border border-gray-250v2 shadow-sm p-6 flex gap-4 items-start">
      <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
        {icon}
      </div>
      <div className="flex flex-col gap-1">
        <h3 className="font-inter font-medium text-xs tracking-[0.05em] leading-4 uppercase text-gray-550 text-left">
          {title}
        </h3>
        <p className="font-inter font-medium text-2xl text-gray-900 text-left leading-9">
          {count}
        </p>
      </div>
    </div>
  );
}
